import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mapto";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as DTOS from "../FeralScan.dtos";
import { DashboardAction, ERROR_REQUEST, FLAG_PLOT_REQUEST, QUESTION_REFERENCE_DATA_REQUEST, REFERENCE_DATA_REQUEST, REPORT_REQUEST, CREATE_PLOT_REQUEST as CREATE_PLOT_REQUEST, CREATE_PLOT_SUCCESS as CREATE_PLOT_SUCCESS, SAVE_REQUEST, flagPlotSuccess, getQuestionReferenceDataSuccess, getReferenceDataRequest, getReferenceDataSuccess, reportSuccess, createPlotSuccessAction as createPlotSuccessAction, UPDATE_PLOT_REQUEST, IUpdatePlotRequest, updatePlotSuccess, ICreatePlotRequest, UPLOAD_PLOT_PHOTOS_REQUEST, IUploadPlotPhotosRequest, uploadPlotPhotosSuccess, uploadPlotPhotosFailure, FILE_DELETE_REQUEST, IDeleteFileRequest, deleteFileSuccess } from "../actions/dashboard.actions";
import { DELETE_EVENT_REQUEST, MapAction, deleteEventSuccess } from "../actions/map.actions";
import { GET_EVENT_QUESTIONS_REQUEST, SAVE_EVENT_REQUEST, SurveyAction, UPLOAD_FILES_REQUEST, clearSurveyRequest, getEventQuestionsSuccess, saveEventSuccess, uploadFilesSuccess, saveEventFailure } from "../actions/survey.actions";
import { getCurrentUserRequest } from "../actions/user.actions";
import { getUserPlotsRequest } from "../actions/data.actions";
import * as ErrorHandler from "../common/errorHandler";
import { addNotification as notify } from "reapop";
import { serviceApi } from "../services/dashboard.service";
import * as fileService from "../services/file.service";
import * as NotificationsActionCreators from "../common/notification";
import * as Configuration from '../configuration';


export const report = action$ =>
    action$
        .ofType(REPORT_REQUEST)
        .mergeMap((action: DashboardAction) =>
            serviceApi
                .report(action.filters)
                .mergeMap(response => {
                    var win = window.open(response.result, "Report", "");
                    return concat$(
                        Observable.of(reportSuccess(response))
                    )
                })
                .catch((error: DTOS.ReportResponse) => ErrorHandler.FireErrorActions(error))
        );

export const save = action$ =>
    action$
        .ofType(SAVE_REQUEST)
        .mergeMap((action: DashboardAction) =>
            serviceApi
                .save(action.preference, action.filters)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getReferenceDataRequest())
                    )
                })
                .catch((error: DTOS.SaveResponse) => ErrorHandler.FireErrorActions(error))
        );

export const deletePlotEvent = action$ =>
    action$
        .ofType(DELETE_EVENT_REQUEST)
        .mergeMap((action: MapAction) =>
            serviceApi
                .deletePlotEvent(action.plotEventId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(deleteEventSuccess(response))
                    )
                })
                .catch((error: DTOS.DeletePlotEventResponse) => ErrorHandler.FireErrorActions(error))
        );

export const flagPlot = action$ =>
    action$
        .ofType(FLAG_PLOT_REQUEST)
        .mergeMap((action: DashboardAction) =>
            serviceApi
                .flagPlot(action.plot)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(flagPlotSuccess(response))
                    )
                })
                .catch((error: DTOS.FlagPlotResponse) => ErrorHandler.FireErrorActions(error))
        );

export const updatePlot = action$ =>
    action$
        .ofType(UPDATE_PLOT_REQUEST)
        .mergeMap((action: IUpdatePlotRequest) =>
            serviceApi
                .updatePlot(action.plot)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(updatePlotSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const uploadPlotPhotos = action$ =>
    action$
        .ofType(UPLOAD_PLOT_PHOTOS_REQUEST)
        .mergeMap((action: IUploadPlotPhotosRequest) =>
            serviceApi
                .uploadPlotPhotos(action.files, action.plotId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(uploadPlotPhotosSuccess(response))
                    )
                })
                .catch(error => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error)
                        , Observable.of(uploadPlotPhotosFailure())
                    )
                })
        );


export const createPlot = action$ =>
    action$
        .ofType(CREATE_PLOT_REQUEST)
        .mergeMap((action: ICreatePlotRequest) =>
            serviceApi
                .createPlot(action.plot)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(createPlotSuccessAction(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const createPlotSuccess = action$ =>
    action$
        .ofType(CREATE_PLOT_SUCCESS)
        .mergeMap((action: DashboardAction) => {
            return concat$(
                Observable.of(getUserPlotsRequest(false))
            )
        });


export const getReferenceData = action$ =>
    action$
        .ofType(REFERENCE_DATA_REQUEST)
        .mergeMap((action: DashboardAction) =>
            serviceApi
                .getReferenceData()
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getReferenceDataSuccess(response)),
                        //Observable.of(getCurrentUserRequest())
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const getQuestionReferenceData = action$ =>
    action$
        .ofType(QUESTION_REFERENCE_DATA_REQUEST)
        .mergeMap((action: DashboardAction) =>
            serviceApi
                .getQuestionReferenceData(action.classifications)
                .mergeMap(response => { return concat$(Observable.of(getQuestionReferenceDataSuccess(response))) })
                .catch((error: DTOS.GetQuestionReferenceDataResponse) => ErrorHandler.FireErrorActions(error))
        );

export const submitSurvey = action$ =>
    action$
        .ofType(SAVE_EVENT_REQUEST)
        .mergeMap((action: SurveyAction) =>
            serviceApi
                .submitSurvey(action.survey)
                .mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifySuccess("", Configuration.content.Survey.SubmitSuccessMessage, 50000));
                    return concat$(
                        Observable.of(notification),
                        Observable.of(saveEventSuccess(response))
                    );

                })
                .catch(error => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error)
                        , Observable.of(saveEventFailure())
                    )
                })
        );

export const getEventQuestions = action$ =>
    action$
        .ofType(GET_EVENT_QUESTIONS_REQUEST)
        .mergeMap((action: SurveyAction) =>
            serviceApi
                .getEventQuestions(action.speciesId, action.eventTypeId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getEventQuestionsSuccess(response))
                    )
                })
                .catch((error: DTOS.SurveyResponse) => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error),
                        Observable.of(clearSurveyRequest())
                    )
                })
        );

export const uploadFiles = action$ =>
    action$
        .ofType(UPLOAD_FILES_REQUEST)
        .mergeMap((action: SurveyAction) =>
            fileService.serviceApi
                .uploadFiles(action.files)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(uploadFilesSuccess(action.questionIndex, response.uploadedFile))
                    )
                })
                .catch((error: DTOS.UploadResponse) => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error)
                    )
                })
        );

export const deleteFile = action$ =>
    action$
        .ofType(FILE_DELETE_REQUEST)
        .mergeMap((action: IDeleteFileRequest) =>
            fileService.serviceApi
                .deleteFile(action.fileId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(deleteFileSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const error = action$ =>
    action$
        .ofType(ERROR_REQUEST)
        .mergeMap((action: DashboardAction) => {
            return concat$(
                ErrorHandler.FireErrorActions(action.errorMessage)
            );
        });